import React from "react";
import Autosuggest from "react-autosuggest";
import "./HeSearch.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faSearch } from "@fortawesome/free-solid-svg-icons";

import throttle from 'lodash/throttle';

import PropTypes from "prop-types";

// add a custom icon
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import {faUSFWS} from "./assets/icon_usfws";

import { getLambdaEndpoint } from '../../helpers/lambdaHelper';

library.add(faUSFWS);
dom.watch();

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => {
    return suggestion.label;
};

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => {
    let icon = faMapMarkerAlt;
    if (suggestion.owner && suggestion.owner === "usfws") {
        icon = faUSFWS;
    }
    return (
        <div style={{ display: "grid", gridTemplateColumns: "25px auto" }}>
            <FontAwesomeIcon icon={icon} className="heSearch-resultIcon" />
            <div>
                <span style={{ color: "rgb(68,68,68)" }}>{suggestion.label}</span>
                {renderSuggestionDescription(suggestion)}
            </div>
        </div>
    );
};
const renderSuggestionDescription = suggestion => {
    if (suggestion.desc) {
        return <span style={{ color: "#9b9b9b", fontSize: "0.9em" }}> ({suggestion.desc})</span>;
    } else {
        return null;
    }
};

class HeSearch extends React.Component {
    constructor(props) {
        super(props);

        this.selectRef = React.createRef();
        
        this.state = {
            moreSuggestions: false,
            lastSelection: "",
            value: "",
            suggestions: [],
            isFocused:false,
            fetching:false
        };

        this.updateSuggestions = throttle(this.updateSuggestions.bind(this),500);
        this.onChange = this.onChange.bind(this);
        this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
        this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
        this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
        this.storeInputReference = this.storeInputReference.bind(this);
        this.shouldRenderSuggestions = this.shouldRenderSuggestions.bind(this);
        this.renderSuggestionsContainer = this.renderSuggestionsContainer.bind(this);
    }

    componentDidMount() {
        let _this = this;
        this.input.addEventListener("click", function(e) {
            if (_this.input.value !== "" && _this.props.clearOnClick && _this.state.lastSelection === _this.input.value) {
                _this.setState({ value: "", suggestion: [] }, () => {
                    _this.forceUpdateOnSuggestions(false);
                });
            }
        });
        this.input.addEventListener("focus", ()=>{
            this.setState({isFocused:true});
        });
        this.input.addEventListener("blur", ()=>{
            this.setState({isFocused:false});
        });
        if (this.props.onInputFocus) {
            this.input.addEventListener("focus", this.props.onInputFocus);
        }
    }

    componentDidUpdate() {
        this.input.placeholder = !this.props.filter ? this.props.placeholder : this.props.placeholder.replace("?", " in " + this.props.filter + "?");
    }

    updateSuggestions(value,reason) {

        let _this = this;
        const inputValue = value.trim().toLowerCase();
        if (inputValue.length < this.props.mininumInputLength) {
            this.setState({
                suggestions: []
            });
            return;
        }
        const maxResults = this.props.initialAsyncResultCount;
        let suggestions = [];

        if (this.props.geoTypes) {
            this.setState({fetching:true})
            let url = getLambdaEndpoint();
            url += "?flavor=fetchSearchData";
            url += "&geoTypes=" + this.props.geoTypes;
            url += "&limit=" + this.props.initialAsyncResultCount.toString();
            if (reason === 'suggestions-revealed'){
                url += "&offset=" + this.state.suggestions.length.toString();
            }
            
            if (value !== "") {
                url += "&nameLike=" + value;
            }
            //filter by geographic area
            if (this.props.geoFilterId && this.props.geoFilterId !== ''){
                url += "&geoFilterId=" + this.props.geoFilterId;
            }
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    if (!data.message || data.message !== "Internal server error"){
                        let newState = { 
                            suggestions: reason === 'suggestions-revealed' ? this.state.suggestions.concat(data.data) : data.data,
                            moreSuggestions: false,
                            fetching:false
                        }
                        if (data.data.length === maxResults){
                            newState.moreSuggestions = true;
                        }
                        this.setState(newState);
                    }
                });
        } else if (this.props.data) {
            this.props.data.forEach(function(suggestion) {
                // if (suggestions.length === maxResults) {
                //     _this.setState({ moreSuggestions: true });
                //     return;
                // }
                let exclude = false;

                if (_this.props.filter && suggestion.stateNames.indexOf(_this.props.filter) === -1) {
                    exclude = true;
                } else if (suggestion.label.toLowerCase().indexOf(inputValue) === -1) {
                    exclude = true;
                }
                if (!exclude) {
                    suggestions.push(suggestion);
                }
            });
            // if (suggestions.length < maxResults) {
            //     _this.setState({ moreSuggestions: false });
            // }
            this.setState({
                suggestions: suggestions
            });
        }

    }

    onChange (event, { newValue }) {
        this.setState({
            value: newValue
        });
    }

    // Autosuggest will call this function every time you need to update suggestions.
    // You already implemented this logic above, so just use it.
    onSuggestionsFetchRequested ({ value, reason }){
        this.updateSuggestions(value,reason);

    }

    onSuggestionSelected (event, { suggestion }) {
        let _this = this;
        this.props.onSelect(suggestion);
        if (this.props.clearOnSelect) {
            this.setState({ value: "", lastSelection: suggestion.label });
        } else {
            this.setState({ lastSelection: suggestion.label });
            this.input.blur();
        }
        if (this.props.blurOnSelect) {
            _this.input.blur();
        }
    }
    // Autosuggest will call this function every time you need to clear suggestions.
    onSuggestionsClearRequested() {
        this.setState({
            suggestions: []
        });
    }

    storeInputReference (autosuggest) {
        if (autosuggest !== null) {
            this.input = autosuggest.input;
        }
    }

    shouldRenderSuggestions (out ) {
        return true;
    }

    render() {
        // Autosuggest will pass through all these props to the input.
        const inputProps = {
            placeholder: this.props.placeholder,
            value: this.state.value,
            onChange: this.onChange,
            autoComplete: "nope" // for chrome autocomplete since it ignores 'off' and 'false'
        };

        return (
            <div
                className={"heSearch-layoutGrid " + this.props.customClass}
                style={{
                    display: "grid",
                    gridTemplateColumns: "auto"
                    // this.state.stateList.length === 0
                    //     ? "auto"
                    //     : "auto 200px"
                }}
            >
                <div className={"heSearch-searchBox"+(this.props.defaultStyle?" heSearch-searchBox-defaultStyle":"")}>
                    <Autosuggest
                        ref={this.storeInputReference}
                        suggestions={this.state.suggestions}
                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                        onSuggestionSelected={this.onSuggestionSelected}
                        shouldRenderSuggestions={this.shouldRenderSuggestions}
                        getSuggestionValue={getSuggestionValue}
                        renderSuggestion={renderSuggestion}
                        focusInputOnSuggestionClick={false}
                        inputProps={inputProps}
                        renderSuggestionsContainer={this.renderSuggestionsContainer}
                    />
                    {this.renderIcon()}
                </div>
                {this.renderNoResultsMessage()}
            </div>
        );
    }

    renderIcon(){
        if (!this.props.defaultStyle) return null;
        return (
            <FontAwesomeIcon icon={faSearch} className="heSearch-searchIcon" />
        );
    }

    renderNoResultsMessage(){
        if (this.state.fetching || this.state.value==="" || this.state.suggestions.length > 0 || this.state.value === this.state.lastSelection || !this.state.isFocused) return null;
        return (
            <div className="heSearch-no-suggestions">
                {this.props.noResultsMessage}
            </div>
        );
    }

    renderSuggestionsContainer ({ containerProps, children, query }) {
        return (
            <div {...containerProps}>
                {children}
                {this.renderShowMoreFooter()}
            </div>
        );
    }

    renderShowMoreFooter() {
        let _this = this;
        if (this.state.moreSuggestions) {
            return (
                <div className="heSearch-searchBox-footer">
                    Showing first {this.state.suggestions.length} results
                    <button
                        style={{ marginLeft: 20 }}
                        onClick={() => {
                            _this.forceUpdateOnSuggestions(true);
                        }}
                    >
                        Show More
                    </button>
                </div>
            );
        } else return null;
    }

    forceUpdateOnSuggestions(showAll) {
        let _this = this;
        this.setState({ value: _this.state.value, moreSuggestions: false }, () => {
            _this.onSuggestionsFetchRequested({ value: _this.state.value, reason: "suggestions-revealed" });
        });
    } 
}

HeSearch.propTypes = {
    /** An array of to search and select on. Required if geoTypes is not provided */
    data: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            desc: PropTypes.string
        })
    ),
    /** An array of  */
    geoTypes: PropTypes.string,
    // geoFilterType: PropTypes.string,
    geoFilterId: PropTypes.string,

    /** A funciton that will run when the a selection is made */
    onSelect: PropTypes.func.isRequired,
    /** Custom styling */
    customClass: PropTypes.string,
    /** on click3 */
    clearOnClick: PropTypes.bool,
    clearOnSelect: PropTypes.bool,
    blurOnSelect: PropTypes.bool,
    placeholder: PropTypes.string,
    filter: PropTypes.string,

    noResultsMessage: PropTypes.string,
    defaultStyle:PropTypes.bool,

    mininumInputLength: PropTypes.number,

    // /** unique name for the input element */
    // name: PropTypes.string.isRequired,

    /** Use the full screen when the suggestions are shown */
    fullScreen: PropTypes.bool,
    initialAsyncResultCount:PropTypes.number
};
HeSearch.defaultProps = {
    customClass: "",
    clearOnClick: true,
    blurOnSelect: true,
    fullScreen: false,
    noResultsMessage: 'No suggestions',
    defaultStyle: true,
    initialAsyncResultCount:100,
    mininumInputLength:0
};

export default HeSearch;
